import PropTypes from "prop-types";
import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../../hocs/withTranslations";
import NotificationDesktop from "./NotificationDesktop";
import NotificationMobile from "./NotificationMobile";
import { NOTIFICATION_TAG_TYPES } from "./NotificationTag";

const Notification = ({ isDesktop, ...rest }) => {
  if (isDesktop) return <NotificationDesktop {...rest} />;

  return <NotificationMobile {...rest} />;
};

export const notificationPropTypes = {
  isDesktop: PropTypes.bool,
  date: PropTypes.string,
  read: PropTypes.bool,
  icon: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    tag: PropTypes.shape({
      type: PropTypes.oneOf(Object.values(NOTIFICATION_TAG_TYPES)),
      text: PropTypes.string.isRequired,
      prefix: PropTypes.string
    })
  }),
  subtitle: PropTypes.string,
  title: PropTypes.string,
  beforeDescription: PropTypes.node,
  subMessage: PropTypes.string,
  description: PropTypes.string,
  stock: PropTypes.shape({
    ticker: PropTypes.string,
    market: PropTypes.string
  }),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(Object.values(NOTIFICATION_TAG_TYPES)),
      text: PropTypes.string.isRequired,
      prefix: PropTypes.string
    })
  ),
  leftAccent: PropTypes.bool
};

Notification.propTypes = notificationPropTypes;
export default compose(withTranslations)(Notification);
